import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import numeral from 'numeral';
import 'numeral/locales/ja';
import Bugsnag from '@bugsnag/js'

import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

import Root from './components/Root';
import routes from './routes';

import './bugsnag';
import './bootstrap.scss';
import './flex-table.scss';
import './index.css';
import './mentions.css';

numeral.locale('ja');

const ErrorBoundary = ['production', 'staging'].includes(process.env.REACT_APP_ENV) ? Bugsnag.getPlugin('react') : Fragment;

ReactDOM.render(
  <ErrorBoundary>
    <Root routes={routes} />
  </ErrorBoundary>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}
